import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import './fontawesome';

import './render';
